// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let ButtonsV5 = require("../../common/Components/ButtonsV5.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyWizardFormRelay = require("./PropertyWizardFormRelay.bs.js");
let PropertyWizardRelaySaveDraft_formState_graphql = require("../../../__generated__/PropertyWizardRelaySaveDraft_formState_graphql.bs.js");
let PropertyWizardRelaySaveDraft_localDraft_graphql = require("../../../__generated__/PropertyWizardRelaySaveDraft_localDraft_graphql.bs.js");

let convertFragment = PropertyWizardRelaySaveDraft_localDraft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelaySaveDraft_localDraft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelaySaveDraft_localDraft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelaySaveDraft_localDraft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelaySaveDraft_localDraft_graphql.node, convertFragment, fRef);
}

let LocalDraftFragment_draftV5Status_decode = PropertyWizardRelaySaveDraft_localDraft_graphql.Utils.draftV5Status_decode;

let LocalDraftFragment_draftV5Status_fromString = PropertyWizardRelaySaveDraft_localDraft_graphql.Utils.draftV5Status_fromString;

let LocalDraftFragment = {
  draftV5Status_decode: LocalDraftFragment_draftV5Status_decode,
  draftV5Status_fromString: LocalDraftFragment_draftV5Status_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertFragment$1 = PropertyWizardRelaySaveDraft_formState_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelaySaveDraft_formState_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelaySaveDraft_formState_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyWizardRelaySaveDraft_formState_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelaySaveDraft_formState_graphql.node, convertFragment$1, fRef);
}

let FormStateFragment_localDraftSaveStatus_decode = PropertyWizardRelaySaveDraft_formState_graphql.Utils.localDraftSaveStatus_decode;

let FormStateFragment_localDraftSaveStatus_fromString = PropertyWizardRelaySaveDraft_formState_graphql.Utils.localDraftSaveStatus_fromString;

let FormStateFragment = {
  localDraftSaveStatus_decode: FormStateFragment_localDraftSaveStatus_decode,
  localDraftSaveStatus_fromString: FormStateFragment_localDraftSaveStatus_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function PropertyWizardRelay__SaveDraft$SaveDraftIndicator(props) {
  let match = PropertyWizardFormRelay.Context.use();
  let mode = match.mode;
  let formState = RescriptRelay_Fragment.useFragment(PropertyWizardRelaySaveDraft_formState_graphql.node, convertFragment$1, props.formState);
  let localDraft = RescriptRelay_Fragment.useFragment(PropertyWizardRelaySaveDraft_localDraft_graphql.node, convertFragment, props.localDraft);
  let modeIsBroadcastExisting;
  if (typeof mode !== "object") {
    modeIsBroadcastExisting = false;
  } else {
    switch (mode.TAG) {
      case "Edit" :
        modeIsBroadcastExisting = false;
        break;
      case "Rebroadcast" :
      case "BroadcastQuietSeller" :
        modeIsBroadcastExisting = true;
        break;
    }
  }
  let match$1 = localDraft.status;
  let match$2 = formState.draftSaveStatus;
  if (match$1 === undefined) {
    return null;
  }
  if (match$1 !== "DELETED" && match$1 !== "RESUMABLE_DRAFT" && match$1 !== "DRAFT" && match$1 !== "PUBLISHED" && match$1 !== "EXPIRED") {
    return null;
  }
  switch (match$1) {
    case "DRAFT" :
      switch (match$2) {
        case "FirstSaveInProgress" :
        case "SaveInProgress" :
          if (modeIsBroadcastExisting) {
            return "Saving...";
          }
          break;
      }
      if (typeof mode !== "object") {
        return "This is a new draft. It will be saved once you enter a street address or a city.";
      }
      switch (mode.TAG) {
        case "Edit" :
          return null;
        case "Rebroadcast" :
          return "Changes will be saved as you type so you can resume the rebroadcast later if needed.";
        case "BroadcastQuietSeller" :
          return "Changes will be saved as you type so you can resume the broadcast later if needed.";
      }
      break;
    case "RESUMABLE_DRAFT" :
      switch (match$2) {
        case "NotSaved" :
          return "This is a resumed draft. Changes will be saved as you type.";
        case "FirstSaveInProgress" :
        case "SaveInProgress" :
          return "Saving...";
        case "Saved" :
          return JsxRuntime.jsxs(JsxRuntime.Fragment, {
            children: [
              "Saved! ",
              "View ",
              JsxRuntime.jsx(ButtonsV5.Link.make, {
                href: "/me#drafts",
                children: "My Dashboard"
              }),
              " to see your draft properties."
            ]
          });
        case "SaveFailed" :
          return "There was an error while saving your draft!";
      }
    default:
      return null;
  }
}

let SaveDraftIndicator = {
  LocalDraftFragment: LocalDraftFragment,
  FormStateFragment: FormStateFragment,
  make: PropertyWizardRelay__SaveDraft$SaveDraftIndicator
};

exports.SaveDraftIndicator = SaveDraftIndicator;
/* ButtonsV5 Not a pure module */
